import { Card, FormControlLabel, styled } from '@mui/material';
import { CheckmarkCircleEmpty, CheckmarkCircleFilled } from '~/assets/icons';
import { theme } from '~/shared/styles/theme';

interface Props {
  value: string;
  label: string;
  selected: boolean;
  onChange: (value: string) => void;
  name?: string;
}

export const RadioButtonCard = ({
  value,
  label,
  selected,
  onChange,
  name,
}: Props) => {
  return (
    <StyledCard
      onClick={() => onChange(value)}
      data-testid={`radio-card-${value}`}
      selected={selected}
      elevation={0}
    >
      <StyledFormControlLabel
        control={
          <IconWrapper data-testid={`radio-button-${value}`}>
            <HiddenRadioInput
              type="radio"
              name={name}
              value={value}
              checked={selected}
              onChange={(e) => onChange(e.target.value)}
              aria-label={label}
            />
            {selected ? <CheckmarkCircleFilled /> : <CheckmarkCircleEmpty />}
          </IconWrapper>
        }
        label={label}
        selected={selected}
      />
    </StyledCard>
  );
};

const IconWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});

const HiddenRadioInput = styled('input')({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
});

const StyledCard = styled(Card)<{ selected?: boolean }>(({ selected }) => ({
  padding: selected ? '24px 28px' : '25px 29px',
  borderRadius: '10px',
  border: selected
    ? '2px solid #5b493d'
    : `1px solid ${theme.palette.custom.lightGrayBrown}`,
  cursor: 'pointer',
  // transition: 'all 0.2s ease',
  backgroundColor: selected
    ? theme.palette.common.white
    : theme.palette.custom.offWhite,
  '&:hover': {
    borderColor: theme.palette.custom.mediumBrown,
  },
}));

const StyledFormControlLabel = styled(FormControlLabel)<{ selected?: boolean }>(
  ({ selected }) => ({
    margin: 0,
    gap: '18px',
    '& .MuiFormControlLabel-label': {
      fontSize: '20px',
      color: theme.palette.custom.darkBrown,
      fontWeight: selected ? 700 : 500,
    },
  }),
);
